import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import { findInVNode } from 'utils/vnode';
import { accessNested, joinClasses } from 'utils/utils';
import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	renderShare() {
		const fontStyles = accessNested(this.props, 'appData.styling.fontVariables');
		const copy = this.props.appData.copy;
		const base = super.renderShare();
		const shareBtn = findInVNode(base, '[key="toggle-share"]');
		const extraCta = <span class={joinClasses(s.ctaMobile, fontStyles.headerShare)}>{copy.baseCopy.$SHARE_MOBILE}</span>;
		shareBtn.children.splice(0, 0, extraCta);
		return base;
	}

}
